<template>
  <div>
    <el-form
      ref="form"
      style="margin: 15px;margin-top: 0px;"
      :rules="rules"
      :model="form"
    >
      <el-form-item prop="receiptNum">
        <p style="margin-bottom: 5px;font-weight: bold;">回单号</p>
        <el-input
          v-model="form.receiptNum"
          maxlength="32"
          placeholder="请输入回单号"
        />
      </el-form-item>
      <!-- 实际承运人上传回单照片 receiptImgs -->
      <el-form-item prop="receiptImgs" v-if="receiptImageUrls.length">
        <p style="margin-bottom: 5px;font-weight: bold;">
          实际承运人上传回单照片
        </p>
        <div class="receipt_Imgs">
          <el-image
            v-for="(url, index) in receiptImageUrls"
            :key="index"
            style="width: 100px; height: 100px;margin-right: 10px;"
            :src="url"
            :preview-src-list="receiptImageUrls"
          >
          </el-image>
        </div>
      </el-form-item>
      <el-form-item :required="true">
        <p style="margin-bottom: 5px;font-weight: bold;">回单照片</p>
        <el-upload
          ref="uploadExcel"
          :action="uploadUrl"
          :headers="headers"
          list-type="picture-card"
          :on-success="handleAvatarSuccess"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :before-upload="beforeImgUpload"
          :limit="9"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <div class="dialog-footer">
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import { OrderDetails } from "@/api/transport";
import { deliverReceiptSigned } from "@/api/transport";
import { getToken } from "@/utils/auth";
export default {
  name: "ReceiptMark",
  data() {
    return {
      receiptImageUrls: [],
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      receiptImgsArray: [],
      dialogImageUrl: "",
      dialogVisible: false,
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000"
      },
      form: {
        code: "",
        receiptNum: "",
        receiptImgs: ""
      },
      rules: {
        // receiptNum: [
        //   { required: true, message: "请输入回单号", trigger: "blur" },
        //   { max: 32, message: '长度不超过32个字符', trigger: 'blur' },
        // ]
      }
    };
  },
  methods: {
    init(c) {
      this.$refs.uploadExcel.clearFiles();
      this.$refs["form"].resetFields();
      this.form.code = c;
      this.Getdetails(c);
    },
    Getdetails(code) {
      this.code = code;
      OrderDetails(code).then(response => {
        this.receiptImageUrls = response.data.receiptImageUrls.filter(
          item => item
        );
      });
    },
    // 上传验证
    beforeImgUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png";
      const isLtnM = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,BMP,PNG 格式!");
        return false;
      }
      if (!isLtnM) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      // 获取token值，实时获取
      this.headers.Authorization = "Bearer " + getToken();
      return isJPG && isLtnM;
    },
    handleAvatarSuccess(res, file) {
      if (res.status == 500) {
        this.$message.error(res.msg);
      } else {
        this.receiptImgsArray.push(res.data);
      }
    },
    handleRemove(file, fileList) {
      this.receiptImgsArray = this.receiptImgsArray.filter(
        item => item !== file.response.data
      );
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.receiptImgs = this.receiptImgsArray.join(",");
          // if (!this.form.receiptImgs) {
          //   this.$message({
          //     message: "请上传回单照片",
          //     type: "error"
          //   });
          //   return false;
          // }
          const rLoading = this.openLoading();
          deliverReceiptSigned(this.form).then(response => {
            rLoading.close();
            this.receiptImgsArray = [];
            this.$message({ message: response.msg, type: "success" });
            this.$emit("hideModel");
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 100%;
  text-align: end;
  padding-right: 30px;
}
.receipt_Imgs {
  display: flex;
  flex-wrap: wrap;
}
</style>
